import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as dates from '@simplybenefits/sb-dates';
import { Button, Text, DateInput, Services, Tooltip, Switch, Theme, TextInput, NumberInput, Bubble } from '@simplybenefits/sb-ui-library';
import { saveAmendment } from '../../../actions/accounts.js';
import Grid from "@material-ui/core/Grid";

class AmendmentForm extends Component {
    state = {
        amendment: {
            ...this.props.amendment
        },
        effectiveDateError: this.props.effectiveDateError || false
    };

    _onBlur = () => {
        this.props.saveParentAmendment(this.state.amendment);
    };

    _selectClass = async (classID) => {
        const index = this.state.amendment.requestedBenefitChanges.selectedClasses.indexOf(classID);
        const selectedClasses = this.state.amendment.requestedBenefitChanges.selectedClasses;

        if (index >= 0) {
            selectedClasses.splice(index, 1);
        } else {
            selectedClasses.push(classID);
        }

        await this.setState({
            amendment: {
                ...this.state.amendment,
                requestedBenefitChanges: {
                    ...this.state.amendment.requestedBenefitChanges,
                    selectedClasses
                }
            }
        });
    };

    _handleEffDateChange = async (type, value) => {
        await this.setState({
            amendment: {
                ...this.state.amendment,
                effectiveDate: value
            }
        });

        this.props.saveParentAmendment(this.state.amendment);
    };

    _validateEffectiveDate = async () => {
        let effectiveDateError = await Services.validateInput('effectiveDate', this.state.amendment.effectiveDate);

        if (this.state.amendment.status.toUpperCase() === 'IN PROGRESS') {
            const startOfMonth = dates.getStartOfMonth();
            const effectiveDateUTC = dates.getUTC(this.state.amendment.effectiveDate);

            if (effectiveDateUTC < startOfMonth) {
                effectiveDateError = 'Amendments can only be backed dated to the start of the month.';
            }
        }

        await this.setState({
            effectiveDateError
        });

        if (effectiveDateError) {
            window.scrollTo(0, 0);
            return false;
        }
        
        return true;
    };

    _toggleBenefitBlock = async (benefitKey) => {
        const index = this.state.amendment.requestedBenefitChanges.selectedBenefits.indexOf(benefitKey);
        const selectedBenefits = this.state.amendment.requestedBenefitChanges.selectedBenefits;

        if (index >= 0) {
            selectedBenefits.splice(index, 1);
        } else {
            selectedBenefits.push(benefitKey);
        }

        await this.setState({
            amendment: {
                ...this.state.amendment,
                requestedBenefitChanges: {
                    ...this.state.amendment.requestedBenefitChanges,
                    selectedBenefits
                }
            }
        });

        this.props.saveParentAmendment(this.state.amendment);
    };

    _saveAmendment = async () => {
        const isEffectiveDateValid = await this._validateEffectiveDate();

        if (!isEffectiveDateValid) {
            return false;
        }

        const amendment = {
            ...this.state.amendment,
            effectiveDate: dates.getUTC(this.state.amendment.effectiveDate)
        };

        window.scrollTo(0, 0);

        await this.props.dispatch(saveAmendment(this.props.accountID, this.props.amendmentID, amendment));
        await this.props.saveParentAmendment(amendment);

        return null;
    };

    _handleChange = async (type, benefitKey, value) => {
        await this.setState({
            amendment: {
                ...this.state.amendment,
                requestedBenefitChanges: {
                    ...this.state.amendment.requestedBenefitChanges,
                    [benefitKey]: {
                        ...this.state.amendment.requestedBenefitChanges[benefitKey],
                        [type]: value
                    }
                }
            }
        });
    };

    _handleRateChange = async (type, tier, benefitKey, value) => {
        await this.setState({
            amendment: {
                ...this.state.amendment,
                requestedBenefitChanges: {
                    ...this.state.amendment.requestedBenefitChanges,
                    [benefitKey]: {
                        ...this.state.amendment.requestedBenefitChanges[benefitKey],
                        rates: {
                            ...this.state.amendment.requestedBenefitChanges[benefitKey].rates,
                            [type]: {
                                ...this.state.amendment.requestedBenefitChanges[benefitKey].rates[type],
                                [tier]: value
                            }
                        }
                    }
                }
            }
        });
    };

    _handleRequestChangeInputChange = async (type, value) => {
        await this.setState({
            amendment: {
                ...this.state.amendment,
                [type]: value
            }
        });
    };

    _renderBlock = (title, benefitKey) => {
        const isSelected = this.state.amendment.requestedBenefitChanges.selectedBenefits.indexOf(benefitKey) >= 0;
        
        const styles = {
            block: {
                border: "1.5px solid #F1F1F1",
                paddingLeft: 30,
                paddingRight: 30,
                borderRadius: 5,
                marginTop: 20,
                backgroundColor: '#FFFFFF'
            },
            header: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: "space-between",
                borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
                
            },
            headerBorder: {
                borderBottom: "1.5px solid #F1F1F1"
            },
            blockContent: {
                paddingTop: 20,
                paddingBottom: 50
            }
        };

        return (
            <div style={ styles.block }>
                <div style={ styles.header }>
                    <Text
                        large
                        bold
                        display="block"
                        margin="20px 0"
                        color={ Theme.colors.skyBlue }
                    >
                        { title }
                    </Text>

                    <Switch
                        checked={ isSelected }
                        onChange={ () => this._toggleBenefitBlock(benefitKey) }
                    />
                </div>

                {
                    isSelected &&
                    <div style={ styles.blockContent }>
                        <TextInput
                            label="Requested Changes"
                            fullWidth
                            value={ this.state.amendment.requestedBenefitChanges[benefitKey].changes || '' }
                            variant="outlined"
                            onChange={(e) => this._handleChange("changes", benefitKey, e.target.value)}
                            multiline={ true }
                            rows={ 5 }
                            onBlur={() => this._onBlur()}
                        />

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Solo Rate (Current)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.current.solo || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("current", "solo", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Duo Rate (Current)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.current.duo || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("current", "duo", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Family Rate (Current)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.current.family || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("current", "family", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Solo Rate (New)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.new.solo || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("new", "solo", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Duo Rate (New)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.new.duo || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("new", "duo", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <NumberInput
                                    prefix="$"
                                    label="Family Rate (New)"
                                    decimalPlaces={3}
                                    fullWidth
                                    value={ this.state.amendment.requestedBenefitChanges[benefitKey].rates.new.family || '' }
                                    variant="outlined"
                                    onChange={(e) => this._handleRateChange("new", "family", benefitKey, e.target.value)}
                                    onBlur={() => this._onBlur()}
                                />
                            </Grid>
                        </Grid>
                    </div>
                }
            </div>
        );
    };

    render() {
        return (
            <div>
                <DateInput
                    label="Effective Date (YYYY/MM/DD)"
                    value={this.state.amendment.effectiveDate}
                    variant="outlined"
                    onChange={(e) => this._handleEffDateChange('effectiveDate', e.target.value)}
                    onBlur={() => this._onBlur()}
                    error={Boolean(this.state.effectiveDateError)}
                    helperText={this.state.effectiveDateError || 'Once the amendment is approved and a revision is completed this is the date the revision changes are effective.' }
                    fullWidth
                    required
                />

                <Text
                    large
                    color={ Theme.colors.mainTextGrey }
                    customStyle={{ flex: '1', marginTop: 20 }}
                >
                    Account Detail Changes
                </Text>

                <TextInput
                    label="Requested Changes for Account Details"
                    fullWidth
                    variant="outlined"
                    multiline={ true }
                    rows={ 5 }
                    value={ this.state.amendment.requestedAccountDetailChanges }
                    onChange={(e) => this._handleRequestChangeInputChange("requestedAccountDetailChanges", e.target.value)}
                    onBlur={() => this._onBlur()}
                />

                <Text
                    large
                    color={ Theme.colors.mainTextGrey }
                    customStyle={{ flex: '1', marginTop: 20 }}
                >
                    Class Changes
                </Text>

                <TextInput
                    label="Requested Changes for Classes"
                    fullWidth
                    variant="outlined"
                    multiline={ true }
                    rows={ 5 }
                    value={ this.state.amendment.requestedClassChanges }
                    onChange={(e) => this._handleRequestChangeInputChange("requestedClassChanges", e.target.value)}
                    onBlur={() => this._onBlur()}
                />

                <Text
                    large
                    color={ Theme.colors.mainTextGrey }
                    customStyle={{ flex: '1', marginTop: 20 }}
                >
                    Division Changes
                </Text>

                <TextInput
                    label="Requested Changes for Divisions"
                    fullWidth
                    variant="outlined"
                    multiline={ true }
                    rows={ 5 }
                    value={ this.state.amendment.requestedDivisionChanges }
                    onChange={(e) => this._handleRequestChangeInputChange("requestedDivisionChanges", e.target.value)}
                    onBlur={() => this._onBlur()}
                />

                <Text
                    large
                    color={ Theme.colors.mainTextGrey }
                    customStyle={{ flex: '1', marginTop: 20 }}
                >
                    Admin Fee Changes
                </Text>

                <TextInput
                    label="Requested Changes for Admin Fees"
                    fullWidth
                    variant="outlined"
                    multiline={ true }
                    rows={ 5 }
                    value={ this.state.amendment.requestedAdminFeeChanges }
                    onChange={(e) => this._handleRequestChangeInputChange("requestedAdminFeeChanges", e.target.value)}
                    onBlur={() => this._onBlur()}
                />

                <Text
                    large
                    color={ Theme.colors.mainTextGrey }
                    customStyle={{ flex: '1', marginTop: 20 }}
                >
                    Benefit Changes
                </Text>

                <Text small>
                    Select the classes you would like to apply the below changes to.
                </Text>

                {
                    Object.keys(this.props.classData).map((key) => {
                        const item = this.props.classData[key];
                        
                        return (
                            <Tooltip
                                tip={ item.description }
                                placement="top"
                                arrow
                                display="inline-block"
                                key={key}
                            >
                                <Bubble
                                    label={ item.title }
                                    isSelected={ this.state.amendment.requestedBenefitChanges.selectedClasses.indexOf(item.classID) >= 0 }
                                    onClick={ () => this._selectClass(item.classID) }
                                    customStyle={{ marginRight: "8px" }}
                                />
                            </Tooltip>
                        );
                    })
                }

                { this._renderBlock('Life Insurance', 'lifeInsurance') }
                { this._renderBlock('AD&D', 'add') }
                { this._renderBlock('Dependent Life', 'dependentLife') }
                { this._renderBlock('Short Term Disability', 'std') }
                { this._renderBlock('Long Term Disability', 'ltd') }
                { this._renderBlock('Critical Illness', 'criticalIllness') }
                { this._renderBlock('Drugs', 'drugs') }
                { this._renderBlock('Healthcare', 'healthcare') }
                { this._renderBlock('Dental', 'dental') }
                { this._renderBlock('Spending Accounts', 'spendingAccounts') }
                { this._renderBlock('EFAP', 'efap') }
                { this._renderBlock('Virtual Healthcare', 'virtualHealthcare') }
                { this._renderBlock('Financial Awareness', 'financialAwareness') }

                <Button
                    color="primary"
                    customStyle={{
                        height: 50,
                        width: 200,
                        textTransform: "capitalize",
                        fontSize: 16,
                        marginTop: "40px",
                        marginLeft: 'auto',
                        display: 'block'
                    }}
                    onClick={ this._saveAmendment }
                >
                    Save Amendment
                </Button>
            </div>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    classData: state.accounts.currentAccount.classes
});

export default (connect(mapStateToProps)(AmendmentForm));